import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Form, Input } from "antd";
import CrudButtons from "components/button/crudbuttons";
import FormItem from "components/fields/FormItem";
import { 
  getEmployeeDetails, 
  doEmployeeCreate, 
  doEmployeeUpdate 
} from "../../../../redux/employee/employeeState";
import { emailField, requiredField } from "utils/crudSagaHelper";


const EmergencyContactForm = ({ 
  recordData, 
  getRecord, 
  doUpdate, 
  onCancel, 
  recordId,
  submitLabel,
  ...props
}) => {

  const [form] = Form.useForm();
  const { mode } = props;

  useEffect(() => {
    if(recordId){
      getRecord(recordId);
    }
  }, [recordId, getRecord]);
  
  useEffect(() => {
    if (recordData) {
      form.resetFields();
      const { user_detail: userDetail, ...rest } = recordData;

      const initialValues = {
        ...rest,
        ...userDetail,
        ...userDetail?.emergency_contact_person,
      };

      form.setFieldsValue(initialValues);
    }
  }, [recordData, form]);

  const onSubmit = (formData) => {
    console.log("formData:", formData);
    try {
      const {
        user_detail,
        clientList,
        countryList,
        departmentList,
        employmentStatusList,
        employmentTypeList,
        jobLevelList,
        client,
        ...employeeFields
      } = recordData;
      const payload = {
        ...employeeFields,
        ...formData,
        emp_id: recordData?.emp_id,
        ude_first_name: user_detail.ude_first_name,
        ude_last_name: user_detail.ude_last_name,
        type: "emergency",
        cde_type: "emergency",
      };
      doUpdate(payload);
  
    } catch (error) {
      console.error("Save failed:", error);
    }
  };

  return (
    <Form className="form" 
      layout="vertical" 
      form={form} 
      onFinish={onSubmit}
    >
      <div className="mb-0">
        <div className="grid grid-cols-3 gap-y-2 gap-x-4 px-2 w-full">
          <FormItem
            label="First Name"
            name="cde_first_name"
            rules={[requiredField()]}
          >
            <Input id="cde_first_name"
              className="input-field"
              maxLength={100}
            />
          </FormItem>
          <FormItem
            label="Last Name"
            name="cde_last_name"
            rules={[requiredField()]}
          >
            <Input id="cde_last_name"
              className="input-field"
              maxLength={100}
            />
          </FormItem>
          <FormItem
            label="Middle Name"
            name="cde_middle_name"
          >
            <Input id="cde_middle_name"
              className="input-field"
              maxLength={100}
            />
          </FormItem>
          <FormItem
            label="Contact #"
            name="cde_mobile_number"
            rules={[
              {
                pattern: /^[0-9]+(-[0-9]+)*$/,
                message: "Contact number must contain digits only",
              },
            ]}
          >
            <Input type="text"
              id="cde_mobile_number"
              className="input-field"
              placeholder="09xx-xxx-xxxx"
              maxLength={15}
            />
          </FormItem>
          <FormItem
            label="Email"
            name="cde_email"
            rules={[emailField()]}
          >
            <Input type="text"
              className="input-field"
              id="cde_email"
              maxLength={100}
            />
          </FormItem>
          <FormItem
            label="Relation"
            name="cde_relation"
          >
            <Input placeholder="e.g. Spouse, Sibling, etc."
              className="input-field"
              id="cde_relation"
              maxLength={50}
            />
          </FormItem>
        </div>
      </div>

      <div className="w-full flex justify-end">
        {(mode === "edit") && (
            <CrudButtons
            mode={mode}     
            recordId={recordData?.emp_id ?? 0}
            isModal={true}
            modalId={recordData?.emp_id > 0 ? 'edit_emergency_contact' : 'add_emergency_contact'}
            cancelLabel="Cancel"
            doHideModal={onCancel}
            submitLabel={submitLabel}
        />
        )}
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => ({
  recordData: state.employee.employeeDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
  getRecord: (id) => dispatch(getEmployeeDetails(id)),
  doCreate: (data) => dispatch(doEmployeeCreate(data)),
  doUpdate: (data) => dispatch(doEmployeeUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmergencyContactForm);
